import { Grid } from '@mui/material';

import type { AdFieldFurnitureEnum, AdFieldRenovationEnum } from '@/types';
import { FiltersBlock } from './FiltersBlock';
import { icons } from './Icons';

interface FilterOption {
  label: string;
  value: string;
}

interface ConditionSectionProps {
  furnished: AdFieldFurnitureEnum[];
  furnishedOptions: FilterOption[];
  furnishedVisible: boolean;
  onFurnishedChange: (value: AdFieldFurnitureEnum | string, name?: string) => void;
  onRenovationChange: (value: AdFieldRenovationEnum | string, name?: string) => void;
  renovation: AdFieldRenovationEnum[];
  renovationOptions: FilterOption[];
  renovationVisible: boolean;
}

export const ConditionSection = ({
  furnished,
  furnishedOptions,
  furnishedVisible,
  onFurnishedChange,
  onRenovationChange,
  renovation,
  renovationOptions,
  renovationVisible,
}: ConditionSectionProps) => {
  return (
    <>
      {furnishedVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.Furniture />}
            name='furniture'
            type='button'
            size='big'
            title='Furnished'
            options={furnishedOptions}
            activeButton={furnished}
            onClick={onFurnishedChange}
            dataQa='furniture'
          />
        </Grid>
      )}
      {renovationVisible && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.Status />}
            name='renovation'
            type='button'
            size='big'
            title='Status'
            options={renovationOptions}
            activeButton={renovation}
            onClick={onRenovationChange}
            dataQa='renovation_status'
          />
        </Grid>
      )}
    </>
  );
};
